import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the structure of your context data
interface QuantContextType {
  selectedRegions: string[];
  setSelectedRegions: React.Dispatch<React.SetStateAction<string[]>>;
  selectedCategory: string[];
  setSelectedCategory: React.Dispatch<React.SetStateAction<string[]>>;
  noItem: boolean;
  setNoItem: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create the context with a default value
const QuantContext = createContext<QuantContextType | undefined>(undefined);

export const QuantProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [selectedRegions, setSelectedRegions] = useState<string[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string[]>([]);
  const [noItem, setNoItem] = useState(false);

  return (
    <QuantContext.Provider
      value={{
        selectedRegions,
        setSelectedRegions,
        selectedCategory,
        setSelectedCategory,
        noItem,
        setNoItem,
      }}
    >
      {children}
    </QuantContext.Provider>
  );
};

// Custom hook to use the context
export const useQuantContext = () => {
  const context = useContext(QuantContext);
  if (!context) {
    throw new Error('useQuantContext must be used within a ReportProvider');
  }
  return context;
};
